uniform vec3 uColor;
uniform vec3 uColorShift;
uniform float uTime;
uniform float uOpacityVariance;
uniform float uColorVariance;

varying float vLifetime;
varying float vRandom;

void main()
{
    float distanceToCenter = length(gl_PointCoord - 0.5);
    if(distanceToCenter > 0.5)
        discard;

    // Soft edge
    float alpha = 1.0 - smoothstep(0.3, 0.5, distanceToCenter);

    // Opacity variance per particle based on lifetime and random seed
    float opacityNoise = sin(vRandom * 6.2831 + uTime * (0.5 + vRandom * 1.5)) * 0.5 + 0.5;
    alpha *= mix(1.0, opacityNoise, uOpacityVariance);

    // Fade in/out with lifetime
    float fadeIn = smoothstep(0.0, 0.1, vLifetime);
    float fadeOut = 1.0 - smoothstep(0.7, 1.0, vLifetime);
    alpha *= min(fadeIn, fadeOut);

    // Color shift over time — each particle shifts at its own phase
    float colorPhase = sin(vRandom * 6.2831 + uTime * 0.8 + vLifetime * 3.0) * 0.5 + 0.5;
    vec3 color = mix(uColor, uColorShift, colorPhase * uColorVariance);

    gl_FragColor = vec4(color, alpha);

    #include <tonemapping_fragment>
    #include <colorspace_fragment>
}
